export default __webpack_public_path__ + "static/media/bg.af70e9b2.webp";